import React from 'react'
import Link from 'gatsby-link'
import ReactDOM from 'react-dom'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import pic01 from '../images/pic01.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg'
import pic04 from '../images/pic04.jpg'
import pic05 from '../images/pic05.jpg'
import pic06 from '../images/pic06.jpg'
import pic07 from '../images/pic07.jpg'
import pic08 from '../images/pic08.jpg'

class Main extends React.Component {
    render() {

        let close = <div className="close" onClick={() => {
            this.props.onCloseArticle()
        }}></div>

        return (
            <div id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

                <article id="leistungen"
                         className={`${this.props.article === 'leistungen' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`}
                         style={{display: 'none'}}>
                    <h2 className="major">Leistungen</h2>
                    <span className="image main"><img src={pic01} alt=""/></span>
                    <p>Massgeschneiderte Software, die genau Ihren Wünschen entspricht, egal für welche Branche.
                        Maximale Leistung und Effizienz, kombiniert mit einfachster Bedienung. Meine Referenzen umfassen
                        Kunden aus den verschiedensten Branchen: Banken, Versicherungsmakler, Immobilienverwalter,
                        Golfclubs, Tourismus-Anbieter, Werbe-Agenturen, Audiogeräte-Hersteller und viele mehr.</p>
                    <h2 className="major">Technologien</h2>
                    <p>PHP · MySql · JavaScript · Apache · C# · VB.NET · SQL Server · MVC · Contao CMS · jQuery
                        Framework · Kohana Framework · Yii Framework · Laravel Framework · Git SCM</p>
                    {close}
                </article>

                <article id="projekte"
                         className={`${this.props.article === 'projekte' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`}
                         style={{display: 'none'}}>
                    <h2 className="major">projekte</h2>
                    <span className="image main"><a href="https://www.sharednc.com" target="_blank"><img src={pic02}
                                                                                                         alt=""/></a></span>
                    <h4 className=""><a href="https://www.sharednc.com" target="_blank">shareDnC.com</a></h4>
                    <p>Komplett entwickelte MVC Plattform (Laravel) für die Untervermietung ungenutzter Arbeitsplätze
                        und Büroräume, sowohl für den Mieter als auch den Vermieter.
                        Inklusive Nachrichtenverwaltung, Vertragsverwaltung, Rechnungserstellung, Finanzberichte und
                        vieles mehr.</p>


                    <span className="image main"><a href="https://www.sportstaetten-finanzierung.de/"
                                                    target="_blank"><img src={pic08}
                                                                         alt=""/></a></span>
                    <h4 className=""><a href="https://www.sportstaetten-finanzierung.de/"
                                        target="_blank">sportstaetten-finanzierung.de</a></h4>
                    <p>Komplett entwickelte MVC Plattform (Laravel) für die Finanzierung von Sportstättenprojekten und
                        vieles mehr.</p>


                    <span className="image main"><a href="https://www.filmschule.de" target="_blank"><img src={pic06}
                                                                                                          alt=""/></a></span>
                    <h4 className=""><a href="https://www.filmschule.de" target="_blank">filmschule.de</a></h4>
                    <p>Massgeschneidertes Theme für Worpress, mit zahlreichen Anpassungen, eigenen Plugins etc.</p>


                    <span className="image main"><a href="https://www.sportstaettenrechner.de" target="_blank"><img
                        src={pic07}
                        alt=""/></a></span>
                    <h4 className=""><a href="https://www.sportstaettenrechner.de"
                                        target="_blank">sportstaettenrechner.de</a></h4>
                    <p>Komplett entwickelte MVC Plattform (Laravel) für die Erstellung von dynamischen
                        Sportstättenrechnern für variable
                        Projekte. Inklusive Verwaltung, Rechnungserstellung, Finanzberichte und vieles mehr.</p>


                    <span className="image main"><a href="https://www.golf-bonus-card.de" target="_blank"><img
                        src={pic04}
                        alt=""/></a></span>
                    <h4 className=""><a href="https://www.golf-bonus-card.de"
                                        target="_blank">golf-bonus-card.de</a></h4>
                    <p>Software für mobile Geräte (und alle anderen) zur Erstellung, Verwaltung und Einlösen von Rabatt-
                        Gutscheinen für Golfclubs deutschlandweit. Gutscheine können alternativ auf dem Mobilgerät
                        erstellt und eingelöst werden oder als Druckversion ausgegeben werden. Inklusive
                        Kundenverwaltung und Import- und Export- Funktionalität und kompletter CMS-Lösung.</p>


                    <span className="image main"><a href="https://guenstiger-golfen.de" target="_blank"><img src={pic05}
                                                                                                             alt=""/></a></span>
                    <h4 className=""><a href="https://guenstiger-golfen.de" target="_blank">guenstiger-golfen.de</a>
                    </h4>
                    <p>Anpassung und Erweiterung einer quelloffenen CMS-Lösung (Contao) zu einer individuellen
                        CRM-Lösung für Golf-Fernmitgliedschaften, inklusive Rechnungserstellung, Rechnungs- und
                        Mahnungsversand, Clubwechsel, Steuer- und Lastschriftenexport und automatischer
                        Jahresabschluss.</p>

                    <AnchorLink offset='100' href='#main' className="pull-right">Nach oben</AnchorLink>

                    {close}
                </article>

                <article id="person"
                         className={`${this.props.article === 'person' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`}
                         style={{display: 'none'}}>
                    <h2 className="major">person</h2>
                    <span className="image main"><img src={pic03} alt=""/></span>
                    <p>Alexander Baumstark
                        <br/>
                        Haselbergstr. 9
                        <br/>
                        50931 Köln
                        <br/>
                        alex @ baumstarksoft . de</p>
                    {close}
                </article>

                <article id="kontakt"
                         className={`${this.props.article === 'kontakt' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`}
                         style={{display: 'none'}}>
                    <h2 className="major">kontakt</h2>
                    <form method="post" action="https://formspree.io/baumstarksoft@gmail.com">
                        <input type="text" name="_gotcha" style={{display: 'none'}}/>
                        <div className="field half first">
                            <label htmlFor="name">Name</label>
                            <input type="text" name="name" id="name"/>
                        </div>
                        <div className="field half">
                            <label htmlFor="email">Email</label>
                            <input type="text" name="email" id="email"/>
                        </div>
                        <div className="field">
                            <label htmlFor="message">Message</label>
                            <textarea name="message" id="message" rows="4"></textarea>
                        </div>
                        <ul className="actions">
                            <li><input type="submit" value="Send Message" className="special"/></li>
                            <li><input type="reset" value="Reset"/></li>
                        </ul>
                    </form>
                    {/*<ul className="icons">*/}
                    {/*<li><a href="#" className="icon fa-twitter"><span className="label">Twitter</span></a></li>*/}
                    {/*<li><a href="#" className="icon fa-facebook"><span className="label">Facebook</span></a></li>*/}
                    {/*<li><a href="#" className="icon fa-instagram"><span className="label">Instagram</span></a></li>*/}
                    {/*<li><a href="#" className="icon fa-github"><span className="label">GitHub</span></a></li>*/}
                    {/*</ul>*/}
                    {close}
                </article>

            </div>
        )
    }
}

Main.propTypes = {
    route: React.PropTypes.object,
    article: React.PropTypes.string,
    articleTimeout: React.PropTypes.bool,
    onCloseArticle: React.PropTypes.func,
    timeout: React.PropTypes.bool
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.js